import { gql } from '@apollo/client';

export const AscProjectMonthPerContributorFragment = gql`
  fragment AscProjectMonthPerContributor on AscProjectMonthPerContributor {
    id
    month
    year
    allocationPercent
    useAllocationPercent
  }
`;
